const visualizerScriptUrl = 'https://vvs.autosyncstudio.com/express/dist/vvse.js';

let scriptLoadPromise: Promise<void> | undefined;

export function loadAutoSyncVisualizerScript(): Promise<void> {
  const existingScript = window.document.querySelector<HTMLScriptElement>(
    `script[src="${visualizerScriptUrl}"]`,
  );

  if (!scriptLoadPromise && !window.initVvsExpress) {
    const loading = existingScript
      ? new Promise<void>((resolve, reject) => {
          existingScript.addEventListener('load', () => resolve(), { once: true });
          existingScript.addEventListener(
            'error',
            () => reject(new Error('AutoSync script failed to load')),
            { once: true },
          );
        })
      : import(/* webpackIgnore: true */ visualizerScriptUrl);

    scriptLoadPromise = loading.then(
      () => undefined,
      (err: Error) => console.warn(`Failed to load the AutoSync visualizer. ${err.message}`),
    );
  }

  return scriptLoadPromise ?? Promise.resolve();
}
